import { useCallback } from 'react'

import { useRunState } from '../game/provider/useRunState'
import { store, type RunRestartOptions, type RunRestartTarget } from '../stores/store'

export function useRestartRun() {
    const runState = useRunState()

    return useCallback(
        (target: RunRestartTarget = 'countdown', options?: RunRestartOptions) => {
            runState.reset()
            store.requestRunRestart(target, options)
        },
        [runState],
    )
}
